import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useLang } from "@/context/LanguageContext";
import { useCart } from "@/context/CartContext";
import { LanguageToggle } from "@/components/LanguageToggle";
import { useAuth } from "@/context/AuthContext";
import { MagnifyingGlass, ShoppingCart, User, Phone } from "@phosphor-icons/react";

const LOGO = "/logo-servitech.png";

export const ShopHeader = () => {
  const { t, lang } = useLang();
  const { count } = useCart();
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [q, setQ] = useState(params.get("q") || "");

  const submit = (e) => { e.preventDefault(); navigate(`/shop?q=${encodeURIComponent(q)}`); };

  return (
    <header className="sticky top-0 z-50">
      {/* Tier 1 — account bar */}
      <div className="bg-[#2e3a47] text-white/80">
        <div className="mx-auto flex max-w-[1280px] items-center justify-between px-4 py-1.5 text-xs">
          <a href="tel:5144758974" className="flex items-center gap-2 whitespace-nowrap" data-testid="header-phone"><Phone size={13} weight="bold" /> <span className="hidden sm:inline">514-475-8974 · 8h–16h</span></a>
          <div className="flex items-center gap-3 sm:gap-4">
            {user && user.role ? (
              <>
                <button onClick={() => navigate(user.role === "client" ? "/portal" : user.role === "sales_rep" ? "/vendor" : "/admin")} className="flex items-center gap-1 whitespace-nowrap rounded-full bg-primary px-3 py-1 font-bold text-white hover:opacity-90" data-testid="account-link"><User size={13} weight="bold" /> {user.role === "client" ? t.myOrders : user.role === "sales_rep" ? (lang === "en" ? "Vendor zone" : "Zone vendeur") : t.backOffice}</button>
                <button onClick={async () => { await logout(); navigate("/"); }} className="hover:text-white" data-testid="header-logout">{t.logout}</button>
              </>
            ) : (
              <>
                <button onClick={() => navigate("/login")} className="hidden items-center gap-1 hover:text-white sm:flex"><User size={13} weight="bold" /> {t.myAccount}</button>
                <button onClick={() => navigate("/login")} className="hover:text-white">{t.signIn}</button>
              </>
            )}
            <LanguageToggle />
          </div>
        </div>
      </div>

      {/* Tier 2 — logo + search + cart */}
      <div className="border-b border-border bg-white">
        <div className="mx-auto flex max-w-[1280px] flex-wrap items-center gap-4 px-4 py-3">
          <button data-testid="shop-logo" onClick={() => navigate("/")} className="shrink-0">
            <img src={LOGO} alt="Servitech Xpert" className="h-12 w-auto object-contain" />
          </button>
          <form onSubmit={submit} className="order-3 w-full md:order-2 md:flex-1">
            <div className="flex items-center overflow-hidden rounded border border-border">
              <input data-testid="shop-search-input" value={q} onChange={(e) => setQ(e.target.value)} placeholder={t.searchProducts}
                className="w-full px-4 py-2.5 text-sm outline-none" />
              <button type="submit" className="flex items-center gap-2 bg-[#ff5319] px-5 py-2.5 text-sm font-bold uppercase tracking-wide text-white hover:brightness-95 transition">
                <MagnifyingGlass size={18} weight="bold" /> <span className="hidden sm:inline">{t.search}</span>
              </button>
            </div>
          </form>
          <button data-testid="cart-button" onClick={() => navigate("/cart")}
            className="order-2 ml-auto flex items-center gap-3 rounded border border-border bg-[#eef2f5] px-3 py-1.5 md:order-3">
            <div className="flex h-9 w-9 items-center justify-center rounded bg-[#8ca3ba] text-white"><ShoppingCart size={20} weight="bold" /></div>
            <div className="text-left leading-tight">
              <div className="text-sm font-bold uppercase text-[#2e3a47]">{t.myCart}</div>
              <div className="text-[11px] text-muted-foreground">{count > 0 ? `${count} ${t.items}` : t.cartEmpty}</div>
            </div>
          </button>
        </div>
      </div>
    </header>
  );
};
